import { Skeleton } from "@/components/atoms";
import { StateRatesPanel, useCustomRatesContext } from "@/components/organisms";
import { Restricted } from "@/components/pages/Restricted/Restricted";

export const StateRates = () => {
  const { isFetching, activeState: state, isRestricted: isRestrictedPage } = useCustomRatesContext();
  const isRestricted = isRestrictedPage || !state;

  if (isFetching) {
    return (
      <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
      {isRestricted ? <Restricted /> : <StateRatesPanel state={state} />}
    </div>
  );
};
